<template>
	<div>
		<div class="phone-verify-div">
			<van-row>
				<van-col span="12">
					<div class="btn-div" @click="changeType(1)" :class="verifyType == 1?'bg-red':'bg-gray'">本机号码一键验证
					</div>
				</van-col>
				<van-col span="12">
					<div class="btn-div" @click="changeType(2)" :class="verifyType == 2?'bg-red':'bg-gray'">获取短信验证码
					</div>
				</van-col>
			</van-row>
		</div>
		<div class="loading-div" v-if="showVerifyLoading">
			<div>
				<van-loading color="#ffffff" type="spinner" size="100px" text-size="44px" vertical>正在验证本机号码
				</van-loading>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		PhoneNumberServer
	} from 'aliyun_numberauthsdk_web'; //引用npm包
	import {
		getAuthToken,
		verifyPhoneWithToken
	} from '@/request/api';
	import {
		Row,
		Col,
		Loading,
		Notify
	} from 'vant';
	export default {
		name: 'PhoneVerify',
		//verifyType:1-本机号码一键验证 2-获取短信验证码
		//verifyCount:在提交之前如果verifyType ==1 则verifyCount++来触发本机手机验证，验证完成后然后通过back()回调来继续提交，验证失败后不会触发回调方法
		components: {
			[Row.name]: Row,
			[Col.name]: Col,
			[Loading.name]: Loading,
			[Notify.name]: Notify
		},
		props: {
			// ['verifyType', 'mobile', 'verifyCount']
			verifyType: {
				type: Number,
				default: null
			},
			mobile: {
				type: String,
				default: ''
			},
			verifyCount: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				phoneNumberServer: '',
				showVerifyLoading: false,
				autoCount: 0,
				tokenCount: 0,
			}
		},
		created() {
			this.phoneNumberServer = new PhoneNumberServer();
			this.phoneNumberServer.setLoggerEnable();
		},
		watch: {
			verifyCount(newV, old) {
				if (newV < 1 || this.verifyType == 2) {
					return
				}
				this.doVerify()
			}
		},
		methods: {
			changeType(type) {
				this.$emit('changeType', type)
			},
			doVerify() {
				if (this.mobile == '' || this.mobile.length != 11) {
					Notify({
						type: 'danger',
						message: '请输入正确的手机号'
					});
					return
				}
				if (this.showVerifyLoading == true) {
					return
				}
				this.showVerifyLoading = true
				this.getJwtToken()
			},
			getJwtToken() {
				console.log(this.mobile+'---')
				//调用后端接口获取accessToken，jwtToken
				//this.checkAuthAvailable(res.accessToken,res.jwtToken)
				getAuthToken({
					mobile: this.mobile
				}).then(res => {
					if (res.flag == 1) {
						this.showVerifyLoading = false
						this.$emit('back')
					} else {
						console.log('-----------流程开始---------1');
						this.doAuthAvailable(res.accessToken, res.jwtToken)
					}
				}).catch(res => {
					this.showVerifyLoading = false
					Notify({
						type: 'danger',
						message: res.data.message
					});
				})

			},
			doAuthAvailable(accessToken, jwtToken) {
				let _this = this
				console.log('身份鉴权-------2');
				this.phoneNumberServer.checkAuthAvailable({
					phoneNumber: _this.mobile,
					accessToken: accessToken,
					jwtToken: jwtToken,
					success: function(res) {
						console.log('身份鉴权成功---------------2.1-');
						_this.doVerifyToken()
					},
					error: function(res) {
						_this.autoCount++
						//重试两次
						console.log('身份鉴权失败重试两次',_this.autoCount);
						if (_this.autoCount > 1) {
							_this.showVerifyLoading = false
							Notify({
								type: 'danger',
								message: '本机验证失败，请使用当前流量数据所绑定的SIM卡'
							});
							_this.$emit('failCheck')
						} else {
							_this.doAuthAvailable()
						}

					}
				})

			},
			doVerifyToken() {
				let _this = this
				console.log('获取本机号码校验token-----------------3');
				this.phoneNumberServer.getVerifyToken({
					success: function(res) {
						let spToken = res.spToken
						//调用后台验证
						console.log('调用后台验证成功------------3.1');
						_this.doPhoneWithToken(spToken)
					},
					error: function(res) {
						_this.tokenCount++
						console.log('校验本机号码token验证失败,两次');
						if (_this.tokenCount > 1) {
							_this.showVerifyLoading = false
							Notify({
								type: 'danger',
								message: '本机验证失败，请使用当前流量数据所绑定的SIM卡'
							});
							_this.$emit('failCheck')
						} else {
							_this.doVerifyToken()
						}
					}
				});
			},
			doPhoneWithToken(spToken) {
				console.log('后台校验接口----3.2');
				verifyPhoneWithToken({
					phoneNumber: this.mobile,
					spToken: spToken
				}).then(res => {
					if (res == 'PASS') {
						this.showVerifyLoading = false
						console.log('成功-------3.3');
						this.$emit('back')
					} else {
						this.showVerifyLoading = false
						console.log('失败-------3.4');
						Notify({
							type: 'danger',
							message: '本机验证失败，请使用当前流量数据所绑定的SIM卡'
						});
					}
					
				}).catch(res => {
					this.showVerifyLoading = false
					Notify({
						type: 'danger',
						message: res.data.message
					});
				})
			}

		}
	}
</script>

<style scoped>
	.phone-verify-div {
		margin: 20px 0px;
		width: 100%;
		color: #ffffff;
		font-size: 15px;
	}

	.bg-red {
		background-color: #E15345;
	}

	.bg-gray {
		background-color: #636363;
	}

	.btn-div {
		line-height: 50px;
		height: 50px;
		text-align: center;
	}

	.loading-div {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 80px;
		z-index: 1000;
		opacity: 0.9;
	}

	.loading-div>div {
		background-color: #3c3c3c;
		margin-top: 160px;
		padding: 30px 0px;
		border-radius: 10px;
	}
</style>
